import React from 'react';
import Layout from '../../../components/Layout';
import ServicesLayout from '../../../components/ServicesLayout';
import Users from './Users';
const title = 'Zarządzanie Urzędami';

import { isAdminUser } from '../../../lib/utils';

export default {

  path: '/users',
  async action(ctx) {
    const isAdmin = await isAdminUser(ctx);
    if (!isAdmin) {
      return { redirect: '/' };
    }
    return {
      title,
      chunk: 'districts',
      component: <ServicesLayout isAdmin><Users /></ServicesLayout>,
    };
  },
};


// WEBPACK FOOTER //
// src/routes/admin/users/index.js